const iqID = require('../../identifiers');

const parseRadioIds = (_id) => [`${_id}_yes`, `${_id}_no`];

module.exports = {
  questions: {
    generalInvestorRepresentationsandWarranties: [
      {
        id: 'girw-1',
        displayName:
          '1. The undersigned’s interest in the Fund will be acquired for investment, and not with a view to the sale or distribution of any part thereof, and that the undersigned has no present intention of selling, granting participation in, or otherwise distributing the same, but subject nevertheless to any requirement of law that the disposition of the undersigned’s property shall at all times be within the control of the undersigned.',
      },
      {
        id: 'girw-2',
        displayName:
          '2. The undersigned will hold its interest in the Fund for itself beneficially and does not nor will have any contract, undertaking, agreement, or arrangement with any person to sell or transfer to any third person its interest in the Fund and is not acting as nominee or trustee or otherwise on behalf of any other person.',
      },
      {
        id: 'girw-3',
        displayName:
          '3. The undersigned has such knowledge and experience in financial and business matters as to be capable of evaluating the merits and risks of an investment in the Fund.',
      },
      {
        id: 'girw-4',
        displayName:
          '4. The undersigned does not control, nor is controlled by or under common control with, any other investors in the Fund.',
      },
      {
        id: 'girw-5',
        displayName: ` 5. The undersigned would
          be considered, and the interest in the Fund held by the undersigned
          would be considered to be beneficially owned by, “one person” for
          purposes of Section 3(c)(1) of the Investment Company Act of 1940
          (the “1940 Act”).`,
      },
      {
        id: 'girw-6',
        displayName:
          '6. If the undersigned is a partnership, grantor trust, S corporation, or other flow-through entity for federal income tax purposes, the undersigned represents and warrants that it has not been formed or utilized for the purpose of permitting the Fund to satisfy the 100-partner limitation set forth in Treasury Regulation Section 1.7704-1(h)(1)(ii).',
      },
      {
        id: 'girw-7',
        displayName: `7. If the undersigned is a resident of, or domiciled in, any jurisdiction within
          the European Economic Area or the United Kingdom, the undersigned represents and
          warrants that it is a “professional client” within the meaning of
          Annex II to Directive 2014/65/EU of the European Parliament and of
          the Council of 15 May 2014 on markets in financial instruments
          (“MiFID”) on the basis that the undersigned is (please check as
          appropriate):`,
          toolTip: `Terminology in accordance with MiFID.`,
      },
      {
        id: 'girw-8',
        displayName:
          `8. If the undersigned is a resident of, or domiciled in, Switzerland, the
          undersigned represents and warrants that it is (please check as
          appropriate):`,
      },
      {
        id: 'girw-9',
        displayName:
          `9. If the undersigned is a resident of, or domiciled in, any jurisdiction
            within the European Economic Area, the United Kingdom or
            Switzerland, the undersigned, in connection with such prospective
            purchase and admission to the Fund, represents that it will not pursue
            any claim against the Fund, the general partner of the Fund, the
            manager of the Fund, or any of their respective affiliates based on, or
            directly or indirectly related to, (a) the Directive, including without
            limitation any rules, regulations, guidance or interpretations of a
            member state related to the transposition of the Directive, (b) the
            United Kingdom Alternative Investment Fund Managers Regulation,
            or (c) Switzerland’s Collective Investment Schemes Act (“CISA”),
            including without limitation any rules, regulations, guidance or
            interpretations related to the implementation of CISA.`,
        toolTip: ``,
      },
      {
        id: 'girw-10',
        displayName:
          `10. The undersigned acknowledges that neither the General Partner nor its
            affiliates provide, or intend to provide, advice to the Fund with respect to
            investment strategies that are plans or programs for the investment of the
            proceeds of municipal securities or the recommendation of and brokerage
            of municipal escrow investments. The undersigned represents and agrees
            that none of the undersigned’s contributions to the Fund will consist of
            “proceeds of municipal securities,” within the meaning of Rule
            15Ba1-1(m)(1) under the Securities Exchange Act of 1934.
            `,
      },
      {
        id: 'girw-11',
        displayName:
          `11. The undersigned represents that it is not investing in the Fund as a result
          of any form of general solicitation or general advertising, including
          without limitation (i) any advertisement, article, notice or other
          communications published in any newspaper, magazine or other media
          (including any publications via the Internet and any social media
          platforms) or broadcast over television, radio or other media or (ii) any
          seminar or meeting whose attendees were invited by any general
          solicitation or general advertising.`,
      },
      {
        id: 'girw-12',
        displayName:
         `12. If the
          undersigned is an entity, the undersigned represents and warrants
          that (a) its shareholders, partners or other holders of equity or
          beneficial interests are not able to decide individually whether to
          participate in the undersigned’s investment in the Fund, (b) the
          undersigned is not a participant-directed defined contribution plan,
          (c) the amount of the undersigned’s capital commitment to the Fund,
          does not exceed 40% of the undersigned’s total assets and (d) the 
          undersigned was not created solely for the purpose of making this
          investment in the Fund.`,
      },
      {
        id: 'girw-13',
        displayName:
          `13. The undersigned agrees to provide to the Fund, its General Partner or
            its management company, or any of their duly appointed agents
            within 14 days of written request therefore, and periodically
            thereafter, as may be required by law or regulation, such information
            as may be required to fulfill any applicable anti-money laundering,
            anti-terrorist financing or anti-tax avoidance obligations of the Fund,
            its General Partner or its management company, or their affiliated
            entities or designees under relevant legislation and regulatory
            requirements, including, but not limited to, applicable “know your
            customer” rules; the United States Financial Account Tax
            Compliance Act; the OECD Common Reporting Standard; the
            United Kingdom Money Laundering, Terrorist Financing and
            Transfer of Funds (Information on the Payer) Regulations 2017;
            European Union Money Laundering Directives; European Union
            Directive 2003/48/EC on the Taxation of Savings Income and
            European Union Directive 2014/107/EC; in each case, as such laws,
            regulations and directives may be amended, supplemented or
            replaced (together, the “AML/KYC Laws”); and, further, the
            undersigned consents to, and expressly authorizes, the taking of any
            action (including any disclosure to a government entity with relevant
            jurisdiction) in compliance with the AML/KYC Laws by the Fund, its
            General Partner, its management company or their affiliated entities
            or designees.`,
      },
      {
        id: 'girw-14',
        displayName: `14. The undersigned hereby agrees to supply such information to the
          General Partner or its Designated Agent in accordance with their
          instructions; represents, warrants and agrees that all of the
          statements, answers and information provided by the undersigned to
          the General Partner or such agent are true and correct as of the date
          hereof, will be true and correct as of the date of the closing and, as of
          each such date, does not and will not omit to state any material fact
          necessary in order to make the statements contained therein not
          misleading. The undersigned represents, warrants and agrees to
          maintain as current the information and documentation provided to
          General Partner or such agent and thereby furnish to the general
          partner of the Fund an updated IRS Form W-9 or relevant Form W-8
          together with any document requested by General Partner or such
          agent, upon the expiration or obsolescence of any such form
          previously provided, or upon request by the General Partner due to
          publication by the IRS of an updated IRS Form W-9 or W-8.`,
      },
      {
        id: 'girw-15',
        displayName: `15. None of the undersigned and, to the best of its knowledge, any persons
          having a direct or indirect beneficial interest in the interests to be
          acquired under this Investor Questionnaire, (a) appears on the Specially 
          Designated Nationals and Blocked Persons List of the Office
          of Foreign Assets Control in the United States Department of the
          Treasury (“OFAC”) or (b) is a prohibited party under the laws of the
          United States. The undersigned further represents that the
          undersigned does not know or have any reason to suspect that the
          monies used to fund the undersigned’s investment in the Fund are
          derived from, invested for the benefit of, or related in any way to, the
          governments of, or persons within, any country under a U.S. embargo
          enforced by OFAC. The undersigned further represents and warrants
          that the undersigned (i) has conducted thorough due diligence with
          respect to all of its beneficial owners, (ii) has established the identities
          of all beneficial owners and the source of each of the beneficial
          owner’s funds and (iii) will retain evidence of any such identities, any
          such source of funds and any such due diligence. The undersigned
          further represents that the undersigned does not know or have any
          reason to suspect that (x) the monies used to fund the undersigned’s
          investment in the Fund have been or will be derived from or related
          to any illegal activities, including but not limited to, money laundering
          activities, and (y) the proceeds from the undersigned’s investment in
          the Fund will be used to finance any illegal activities. The undersigned
          further agrees and acknowledges that, among other remedial
          measures, (i) the Fund may be obligated to “freeze the account” of
          such undersigned, either by prohibiting additional investments by the
          undersigned and/or segregating assets of the undersigned in
          compliance with governmental regulations and/or if the General
          Partner determines in its good faith that such action is in the best
          interests of the Fund, and may be required to report such action or
          confidential information relating to the undersigned (including,
          without limitation, disclosing the undersigned’s identity) to the
          regulatory authorities.`,
      },
      {
        id: 'girw-16',
        displayName: `16. If the undersigned has answered “yes” to either of the questions in
          Part II.B.1 below (ERISA Partner), the undersigned represents and
          warrants that the undersigned is represented by a plan fiduciary
          that
          is (i) a U.S. bank, U.S. insurance company, U.S. registered investment
          adviser or U.S. registered broker-dealer or (ii) a fiduciary of the
          undersigned that holds, or has under management or control of, total
          assets of at least $50 million. The undersigned acknowledges that
          neither the general partner of the Fund nor any other adviser to the
          Fund is (A) undertaking to provide impartial investment advice, or to
          give advice in a fiduciary capacity, in connection with the sale 
          or issuance of partnership interests of the Fund to the undersigned (the
          “Transaction”), (B) making any recommendation to the undersigned
          or its plan fiduciary with respect to the Transaction, or (C) receiving
          any fee or other compensation directly from the undersigned or its
          plan fiduciary for the provision of investment advice in connection
          with the Transaction.`,
        toolTip:
         `The term “plan fiduciary” means a person described in section (3)(21)(A) of ERISA and 4975(e)(3) of the Code that is
        acting as a fiduciary under ERISA or the Code, or both, with respect to the Transaction and is capable of evaluating
        investment risk, both in general and with respect to the undersigned’s proposed investment in the Fund. For purposes of
        this definition hereunder, a participant or beneficiary of the plan or a relative of either is not a “plan fiduciary” with
        respect to the plan, and the IRA owner or a relative is not a “plan fiduciary” with respect to an IRA.`,
      },
      {
        id: 'girw-17',
        displayName: `17. The undersigned acknowledges that representatives of the Fund have
          made available to the undersigned, during the course of this
          transaction and prior to the purchase of the interest in the Fund, the
          opportunity to ask questions of and receive answers from them
          concerning the terms and conditions of the offering of the Interests
          described in the Partnership Agreement and this Investor
          Questionnaire, and to obtain any additional information necessary to
          verify the information contained in the Partnership Agreement and
          this Investor Questionnaire or otherwise relative to the proposed
          activities of the Fund or to otherwise evaluate the merits and risks of
          an investment in the interest in the Fund.`,
      },
    ],
    girw7: [
       {
        id: iqID.id_girw_7_a,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_a),
        name: 'id_girw_7_a',
        displayName: '1. a credit institution;',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_b,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_b),
        name: 'id_girw_7_b',
        displayName: '2. an investment firm;',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_c,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_c),
        name: 'id_girw_7_c',
        displayName: '3. another authorised or regulated financial institution;',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_d,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_d),
        name: 'id_girw_7_d',
        displayName: '4. an insurance company;',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_e,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_e),
        name: 'id_girw_7_e',
        displayName: '5. a collective investment scheme or a management company of such a scheme;',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_f,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_f),
        name: 'id_girw_7_f',
        displayName: '6. a pension fund or the management company of a pension fund;',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_g,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_g),
        name: 'id_girw_7_g',
        displayName: '7. a commodity or commodity derivatives dealer;',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_h,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_h),
        name: 'id_girw_7_h',
        displayName: '8. a local, i.e. a floor trader acting for its own account; or',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_i,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_i),
        name: 'id_girw_7_i',
        displayName: '9. another institutional investor:',
        isSelected: false,
        type: 'with-input',
      },
    ],
    girw7_2: [
      {
        id: iqID.id_girw_7_2_a,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_2_a),
        name: 'id_girw_7_2_a',
        displayName: `10. a national or regional government, a public body
        that manages public debt at a national or regional level,
        a Central Bank, an international or supranational institution such as the World Bank, the IMF, the ECB,
        the EIB, or another similar international organisation;  or`,
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_2_b,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_2_b),
        name: 'id_girw_7_2_b',
        displayName: '11. another institutional investor whose main activity is to invest in financial instruments; or',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_2_c,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_2_c),
        name: 'id_girw_7_2_c',
        displayName: '12. an entity dedicated to the securitisation of assets or other financing transactions; or',
        isSelected: false,
      },
       {
        id: iqID.id_girw_7_2_d,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_2_d),
        name: 'id_girw_7_2_d',
        displayName: '13. is a large undertaking meeting (at least) two of the following size requirements on a company basis (please check as appropriate):',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_2_e,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_2_e),
        name: 'id_girw_7_2_e',
        displayName: '14. a UK local public authority or municipality, that is an elective professional client properly so classified in accordance with the rules of the UK Financial Conduct Authority; or',
        isSelected: false,
      },
      {
        id: iqID.id_girw_7_2_f,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_7_2_f),
        name: 'id_girw_7_2_f',
        displayName: '15. none of the above (including, but not limited to, non-UK local public authorities or municipalities, or natural persons), but is an elective professional client properly so classified.',
        isSelected: false,
      },
    ],
    griw7_2CompanyBasis: [
      {
        id: iqID.id_griw7_2CompanyBasis_a,
        tooltip: '',
        showHelp: false,
        helpText: '',
        identifier: 'id_griw7_2CompanyBasis_a',
        displayName: '(a) balance sheet total: Euro 20 million',
        isSelected: false,
      },
      {
        id: iqID.id_griw7_2CompanyBasis_b,
        tooltip: '',
        showHelp: false,
        helpText: '',
        identifier: 'id_griw7_2CompanyBasis_a',
        displayName: '(b) net turnover: Euro 40 million',
        isSelected: false,
      },
      {
        id: iqID.id_griw7_2CompanyBasis_c,
        tooltip: '',
        showHelp: false,
        helpText: '',
        identifier: 'id_griw7_2CompanyBasis_a',
        displayName: '(c) own funds: Euro 2 million; or',
        isSelected: false,
      },
    ],
    girw8: [
        {
          id: 'girw-8-title-1',
          displayName: `Institutional Investor`,
          type: 'text',
          className: 'left-align-text'
        },
        {
          id: iqID.id_girw_8_1_a,
          tooltip: '',
          showHelp: false,
          helpText: '',
          radioIdentifier: parseRadioIds(iqID.id_girw_8_1_a),
          name: 'id_girw_8_1_a',
          displayName: `1. a financial intermediary pursuant to the
              Banking Act dated November 8 1934, the Financial
              Institutions Act dated June 15, 2018 or the Collective
              Investment Schemes Act;`,
          isSelected: false,
        },
       {
        id: iqID.id_girw_8_1_b,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_b),
        name: 'id_girw_8_1_b',
        displayName: `2. an insurance company as defined in the Insurance Supervision Act;`,
        isSelected: false,
      },
       {
        id: iqID.id_girw_8_1_c,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_c),
        name: 'id_girw_8_1_c',
        displayName: `3. a foreign client subject to prudential supervision such as the persons listed under (1) and (2) above;`,
        isSelected: false,
      },
       {
        id: iqID.id_girw_8_1_d,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_d),
        name: 'id_girw_7_2_d',
        displayName: '4. a central bank;',
        isSelected: false,
      },
       {
        id: iqID.id_girw_8_1_e,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_e),
        name: 'id_girw_7_2_e',
        displayName: '5. a national or supranational public entity with professional treasury;',
        isSelected: false,
      },
      {
        id: 'girw-8-title-2',
        displayName: `and is aware of the possibility of “opting in” to being a Professional Client but has chosen not do so;`,
        type: 'text',
        className: 'left-align-text'
      },
      {
        id: 'girw-8-title-3',
        displayName: `Other Professional Investor`,
        type: 'text',
        className: 'left-align-text'
      },
      {
        id: iqID.id_girw_8_1_f,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_f),
        name: 'id_girw_7_2_f',
        displayName: '6. a public entity with professional treasury;',
        isSelected: false,
      },
       {
        id: iqID.id_girw_8_1_g,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_g),
        name: 'id_girw_7_2_g',
        displayName: '7. a pension fund or another institution which serves the purpose of an occupational benefits scheme with professional treasury;',
        isSelected: false,
      },
       {
        id: iqID.id_girw_8_1_h,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_h),
        name: 'id_girw_7_2_h',
        displayName: '8. a company with professional treasury;',
        isSelected: false,
      },
       {
        id: iqID.id_girw_8_1_i,
        tooltip: '',
        showHelp: true,
        helpText: ` A large company is a company which exceeds two of the following parameters: (A) balance sheet total of CHF 20
          million; (B) turnover of CHF 40 million; (C) equity of CHF 2 million.`,
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_i),
        name: 'id_girw_7_2_i',
        displayName: '9. a large company;',
        isSelected: false,
        className: 'align-tooltip',
      },
      {
        id: 'girw-8-title-4',
        displayName: `and is aware of the possibility of “opting in” to being a Retail Client but has chosen not do so;`,
        type: 'text',
        className: 'left-align-text move-text-to-top'
      },
       {
        id: iqID.id_girw_8_1_j,
        tooltip: '',
        showHelp: true,
        helpText: `This is only possible if such individual can convincingly declare (i) that it holds assets of at least CHF 500,000 and has
          sufficient professional knowledge or experience to understand the risks related to the investments; or (ii) holds bankable
          assets of at least CHF 2,000,000.`,
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_j),
        name: 'id_girw_7_2_j',
        displayName: `10. a private investment structure with professional
        treasury established for a high-net-worth retail clients
        having requested in writing to be treated as a professional investor (opt-out);`,
        isSelected: false,
        className: 'align-tooltip',
      },
       {
        id: iqID.id_girw_8_1_k,
        tooltip: '',
        showHelp: true,
        helpText: `
          This is only possible if the individual can convincingly declare (i) that it holds assets of at least CHF 500,000 and has
          sufficient professional knowledge or experience to understand the risks related to the investments; or (ii) holds bankable
          assets of at least CHF 2,000,000.`,
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_k),
        name: 'id_girw_8_1_k',
        displayName: `11. a high net worth individual having requested in
        writing to be treated as a professional investor (opt-out); or`,
        isSelected: false,
        className: 'align-tooltip',
      },
       {
        id: iqID.id_girw_8_1_l,
        tooltip: '',
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_girw_8_1_l),
        name: 'id_girw_8_1_l',
        displayName: `12. a retail client for whom discretionary asset
        management or investment advisory services are being
        provided based on a long term written asset
        management or investment advisory agreement with a
        regulated financial intermediary according to (1) above
        or with a foreign asset manager subject to equivalent
        prudential supervision and who has not declared not to
        want to be treated as a Qualified Investor.`,
        isSelected: false,
      },
      {
        id: 'girw-8-title-5',
        displayName: `If the undersigned is a resident of, or domiciled in, Switzerland, the
          undersigned further represents and warrants that (i) it actively
          solicited the Fund’s manager in connection with a prospective
          investment in the Fund, (ii) it approached the Fund’s manager on its
          own initiative, and (iii) its interest in the Fund and the Fund’s
          manager did not come about as a result of any direct or indirect
          marketing, offering or placement efforts by or on behalf of the Fund
          or the Fund’s manager.`,
        type: 'text',
        className: 'left-align-text'
      },
    ],
    identificationofInvestorStatus: [
      {
        id: iqID.id_investor_status_2,
        tooltip: `<span>Section 7701(a)(30) of the Internal Revenue Code defines as “United States Person” to mean (a) a citizen or
resident of the United States, (b) a domestic partnership, (c) a domestic corporation, (d) any estate (other
than a “foreign estate”), and (e) any trust if (i) a court within the United States is able to exercise primary
supervision over the administration of the trust, and (ii) one or more United States persons have the authority
to control all substantial decisions of the trust. A “foreign estate” means an estate the income of which, from
sources within the United States which is not effectively connected with the conduct of a trade or business
within the United States, is not includible in gross income under Subtitle A of the Internal Revenue Code.</span>`,
        radioIdentifier: parseRadioIds(iqID.id_investor_status_2),
        name: 'E_2_quest',
        displayName:
          '2. U.S. Person: Is the undersigned a “United States person” as defined in section 7701(a)(30) of the Internal Revenue Code?',

        size: 'large',
        type: 'quest',
      },
      
    ],
     categoriesOfBeneficialOwnershipQuestions: [
       {
        id: iqID.id_investor_status_7_tcg_a,
        identifier: 'E_7_a_tcg',
        displayName: 'Individual that is a United States person (or a trust of such person)',
        helpText: `“United States person,” for purposes of this question, has the meaning 
        provided in rule 203(m)-1 under the Investment Advisers Act of 1940, which includes, among others, 
        any natural person that is resident in the United States of America, its territories and possessions, any state of 
        the United States, or the District of Columbia.`,
        isSelected: false,
        showHelp: true,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_b,
        identifier: 'E_7_b_tcg',
        displayName: 'Individual that is not a United States person (or a trust of such person)',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_c,
        identifier: 'E_7_c_tcg',
        displayName: 'Broker-dealer',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_d,
        identifier: 'E_7_d_tcg',
        displayName: 'Insurance company',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_e,
        identifier: 'E_7_e_tcg',
        displayName: 'Investment company registered with the SEC',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_f,
        identifier: 'E_7_f_tcg',
        displayName: 'Private fund',
        helpText: `“Private fund,” for purposes of this question, means any issuer that would 
        be an investment company as defined in Section 3 of the Investment Company Act of 1940 but for Section 3(c)(1) or 3(c)(7) of that Act.`,
        isSelected: false,
        showHelp: true,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_g,
        identifier: 'E_7_g_tcg',
        displayName: 'Non-profit',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_h,
        identifier: 'E_7_h_tcg',
        displayName: 'Pension plan (excluding governmental pension plan)',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_i,
        identifier: 'E_7_i_tcg',
        displayName: 'Banking or thrift institution (proprietary)',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_j,
        helpText: `“Government entity,” for purposes of this question, means any U.S. state (including any U.S. state, the District of Columbia, 
          Puerto Rico, the U.S. Virgin Islands or any other possession of the United States) or political subdivision of a state, including: (i) 
          any agency, authority or instrumentality of the state or political subdivision; (ii) a plan or pool of assets controlled by the state or 
          political subdivision or any agency, authority or instrumentality thereof; and (iii) any officer, agent, or employee of the state or political 
          subdivision or any agency, authority or instrumentality thereof, acting in his or her official capacity.`,
        identifier: 'E_7_j_tcg',
        displayName: 'State or municipal government entity (excluding any governmental pension plan)',
        isSelected: false,
        showHelp: true,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_k,
        identifier: 'E_7_k_tcg',
        displayName: 'State or municipal governmental pension plan',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_l,
        identifier: 'E_7_l_tcg',
        displayName: 'Sovereign wealth fund or foreign official institution',
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_m,
        identifier: 'E_7_m_tcg',
        displayName: `An entity wholly owned by a person or entity described 
        in (a)-(l) above or trust whose sole beneficiary is described in (a)-(l) 
        above 
        <br></br> 
        If the above box is checked, please indicate which category in (a)-(l) above 
        best describes the sole owner or beneficiary:`,
        helpText: '',
        isSelected: false,
        showHelp: false,
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_n,
        helpText: '',
        isSelected: false,
        showHelp: false,
        identifier: 'E_7_n_tcg',
        displayName: 'A person or entity (other than as described in (m) above) that is not a United States person and about which the foregoing beneficial ownership information is not known and cannot reasonably be obtained because the beneficial interest is held through a chain involving one or more third-party intermediaries',
        name: '',
      },
      {
        id: iqID.id_investor_status_7_tcg_o,
        helpText: '',
        isSelected: false,
        identifier: 'E_7_o_tcg',
        name: '',
        displayName: 'Other',
        showHelp: false,
      },
    ],
    accreditedInvestorRepresentations: [
      {
        id: iqID.id_investor_representations_1,
        showHelp: true,
        helpText: `For purposes of calculating the net worth of a natural person, the amount of any mortgage or other indebtedness secured by such person’s primary residence must be netted against the value of such residence.  If the amount of such indebtedness is less than the estimated fair market value of such residence, it need not be considered as a liability deducted from such natural person’s net worth (except that if the amount of indebtedness outstanding at the time of the sale of securities exceeds the amount outstanding 60 days before such time, other than as a result of the acquisition of the primary residence, the amount of such excess shall be included as a liability).  If the amount of such indebtedness exceeds the estimated fair market value of such residence, then that excess liability must be deducted from such natural person’s net worth.
          <br/><br/>
          Joint net worth can be calculated as the aggregate net worth of the undersigned and his or her spouse or spousal equivalent; assets need not be held jointly to be included in such calculation. Reliance on the joint net worth standard described herein does not require that the investment in the securities be made jointly by the undersigned and his or her spouse or spousal equivalent.
          <br/><br/>
          “Spousal equivalent” means a cohabitant occupying a relationship generally equivalent to that of a spouse.
          `,
        displayName:
          'A natural person whose individual net worth, or joint net worth with that person’s spouse or spousal equivalent, at the time of his or her purchase exceeds $1,000,000 (excluding the value of the primary residence of such natural person).',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_1',
      },
      {
        id: iqID.id_investor_representations_2,
        showHelp: false,
        helpText: '',
        displayName:
          'A natural person who had an individual income in excess of $200,000 in each of the two most recent years or joint income with that person’s spouse or spousal equivalent in excess of $300,000 in each of those years and has a reasonable expectation of reaching the same income level in the current year.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_2',
      },
      {
        id: iqID.id_investor_representations_3,
        showHelp: false,
        helpText: '',
        displayName: `A bank as defined in section 3(a)(2) of the Securities Act, or any savings and loan association or other institution as defined in section 3(a)(5)(A) of the Securities Act whether acting in its individual or fiduciary capacity; any broker or dealer registered pursuant to section 15 of the Securities Exchange Act of 1934; any investment adviser registered pursuant to section 203 of the Investment Advisers Act of 1940 (as amended, the “Advisers Act”) or registered pursuant to the laws of a state; any investment adviser relying on the exemption from registering with the Securities and Exchange Commission under section 203(l) or (m) of the Advisers Act; any insurance company as defined in section 2(a)(13) of the Securities Act; any investment company registered under the 1940 Act or a business development company as defined in section 2(a)(48) of the 1940 Act; any Small Business Investment Company licensed by the U.S. Small Business Administration under section 301(c) or (d) of the Small Business Investment Act of 1958; any Rural Business Investment Company as defined in section 384A of the Consolidated Farm and Rural Development Act; any plan established and maintained by a state, its political subdivisions, or any agency or instrumentality of a state or its political subdivisions, for the benefit of its employees, if such plan has total assets in excess of $5,000,000; any employee benefit plan within the meaning of the Employee Retirement Income Security Act of 1974 if the investment decision is made by a plan fiduciary, as defined in section 3(21) of such act, which is either a bank, savings and loan association, insurance company, or registered investment adviser, or if the employee benefit plan has total assets in excess of $5,000,000 or, if a self-directed plan, with investment decisions made solely by persons that are accredited investors.`,
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_3',
      },
      {
        id: iqID.id_investor_representations_4,
        showHelp: false,
        helpText: '',
        displayName:
          'A private business development company as defined in section 202(a)(22) of the Investment Advisers Act of 1940.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_4',
      },
      {
        id: iqID.id_investor_representations_5,
        showHelp: false,
        helpText: '',
        displayName:
          `A corporation, limited liability company, partnership,
          organization described in section 501(c)(3) of the
          Internal Revenue Code, or Massachusetts or similar business trust,
          not formed for the specific purpose of acquiring the securities offered,
          with total assets in excess of $5,000,000.`,
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_5',
      },
      {
        id: iqID.id_investor_representations_6,
        showHelp: false,
        helpText: '',
        displayName:
          'A trust, with total assets in excess of $5,000,000, not formed for the specific purpose of acquiring the securities offered, whose purchase is directed by a sophisticated person as described in Rule 506(b)(2)(ii).',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_6',
      },
      {
        id: iqID.id_investor_representations_6_extra,
        showHelp: true,
        helpText: `The term “investments” is generally restricted to the following: (a) stock in publicly held corporations, (b)
limited partnership interests in private investment partnerships such as venture capital, private equity or
hedge funds, (c) interests in registered investment companies such as mutual funds or exchange-traded
funds, (d) cash, commodity interests, and physical commodities held for investment purposes, (e) real estate
held for investment purposes (excluding real estate used for personal purposes or as a place of business)
and (f) stock in privately-held corporations provided that each such privately-held corporation has
shareholder’s equity, determined in accordance with GAAP and as of the date of its most recent financial
statements (within the preceding 16 months), in excess of $50 million.`,
        displayName: `An entity, of a type not listed in the preceding four paragraphs of
        this Section C, not formed for the specific purpose of acquiring the
        securities offered, owning investments (as defined in Rule 2a51-1
        under the 1940 Act) in excess of $5,000,000.`,
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_Extra_6',
      },
      {
        id: iqID.id_investor_representations_7,
        showHelp: false,
        helpText: '',
        displayName:
          'An employee benefit plan or retirement plan in which all of the participants are accredited investors.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_7',
      },
      {
        id: iqID.id_investor_representations_8,
        showHelp: true,
        helpText:
          'The term “revocable grantor trust” means a trust that is a “grantor trust” for U.S. federal income tax purposes, with the grantor or grantors (a) being the sole funding source of the trust, (b) serving as a trustee, or co-trustee, of the trust, (c) having sole investment discretion on behalf of the trust at the time the investment in the Fund is made and (d) having the right to amend or revoke the trust during the life of the grantor.',
        displayName:
          'A revocable grantor trust of which each settlor (i.e., grantor) is a natural person who is an accredited investor.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_8',
      },
      {
        id: iqID.id_investor_representations_9,
        showHelp: false,
        helpText: '',
        displayName:
          'An entity in which all of the equity owners are accredited investors.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_9',
      },
      {
        id: iqID.id_investor_representations_10,
        showHelp: true,
        helpText: `As of August 26, 2020, the Securities and Exchange Commission has designated the General Securities
Representative license (Series 7), the Private Securities Offerings Representative license (Series 82), and
the Investment Adviser Representative license (Series 65) as qualifying natural persons for accredited
investor status pursuant to Rule 501(a)(10) under the Securities Act.`,
        displayName: `A natural person holding in good standing one or more professional
certifications or designations or credentials from an accredited
educational institution that the Securities and Exchange
Commission has designated as qualifying an individual for
accredited investor status.`,
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_10',
      },
      {
        id: iqID.id_investor_representations_11,
        showHelp: false,
        helpText: '',
        displayName: `A family office, as defined in Rule 202(a)(11)(G)-1 under the
Advisers Act with assets under management in excess of $5,000,000,
not formed for the specific purpose of acquiring the securities
offered and whose prospective investment is directed by a person
who has such knowledge and experience in financial and business
matters that such family office is capable of evaluating the merits
and risks of the prospective investment.`,
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_11',
      },
      {
        id: iqID.id_investor_representations_12,
        showHelp: false,
        helpText: '',
        displayName: `A family client, as defined in Rule 202(a)(11)(G)-1 under the
Advisers Act, of a family office meeting the requirements in the
immediately preceding paragraph of this Section C and whose
prospective investment in the Fund is directed by a person who has
such knowledge and experience in financial and business matters
that such family office is capable of evaluating the merits and risks
of the prospective investment.`,
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_12',
      },
      {
        id: iqID.id_investor_representations_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Or, the undersigned hereby represents that: The undersigned is NOT an accredited investor.',
        isSelected: false,
        name: '',
        identifier: 'acre-Or',
      },
    ],
    qualifiedPurchaserRepresentations: [
      {
        id: iqID.id_purchase_representations_1,
        showHelp: true,
        helpText:
         `The term “investments” generally includes cash held for investment purposes and
          securities, other than securities of an issuer that the undersigned controls, is controlled by or under common control with,
          unless such securities are: (a) stock in publicly held corporations, 
          (b) limited partnership interests in private investment 
          partnerships such as venture capital, private equity or hedge funds, 
          (c) interests in registered investment companies such as mutual funds 
          or exchange-traded funds, (d) cash, commodity interests, and physical 
          commodities held for investment purposes, (e) real estate held for investment purposes 
          (excluding real estate used for personal purposes or as a place of business) and (f) stock in privately-held 
          corporations provided that each such privately-held corporation has shareholder’s equity, determined in
          accordance with GAAP and as of the date of its most recent financial statements (within the preceding 16 months), in excess of $50 million.`,
        displayName:
          'A natural person (to include a natural person investing through an individual retirement account or a self-directed employee benefit plan ) who owns at least $5,000,000 in investments (as defined in Rule 2a51-1 under the 1940 Act).',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_1',
      },
      {
        id: iqID.id_purchase_representations_3,
        showHelp: true,
        helpText:
          `The term “company” means a corporation, a partnership, an association, a joint-stock company, a trust, a fund, or any
          organized group of persons whether incorporated or not; or any receiver, trustee in bankruptcy or similar official or any
          liquidating agent for any of the foregoing, in his or her capacity as such.`,
        displayName:
          'A family owned company that (i) was not formed for the specific purpose of investing in the Fund, (ii) owns at least $5,000,000 in investments, and (iii) is owned directly or indirectly by or for two or more natural persons who are related as siblings or spouses (including former spouses), or direct lineal descendants by birth or adoption, spouses of such persons, the estates of such persons, or foundations, charitable organizations, or trusts established by or for the benefit of such persons.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_3',
      },
      {
        id: iqID.id_purchase_representations_4,
        showHelp: false,
        helpText: '',
        displayName:
          'A trust that was not formed for the specific purpose of investing in the Fund, and the trustee or other person authorized to make decisions with respect to the trust and each settlor or other person who has contributed assets to the trust, is a qualified purchaser described in clauses (i), (ii), or (iv) of Section 2(a)(51) of the 1940 Act.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_4',
      },
      {
        id: iqID.id_purchase_representations_2,
        showHelp: false,
        helpText: '',
        displayName:
          'A natural person or a company that was not formed for the specific purpose of investing in the Fund, acting for its own account or the accounts of other qualified purchasers, and who in the aggregate owns and invests on a discretionary basis, at least $25,000,000 in investments (as defined in Rule 2a51-1 under the 1940 Act).',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_2',
      },
      {
        id: iqID.id_purchase_representations_5,
        showHelp: false,
        helpText: '',
        displayName:
          'A qualified institutional buyer as defined in Rule 144A under the Securities Act (not formed for the specific purpose of investing in the Fund), acting for its own account, the account of another qualified institutional buyer, or the account of a qualified purchaser, provided that the undersigned is not (1) a dealer described in Rule 144A(a)(1)(ii), that owns and invests on a discretionary basis less than $25,000,000 in securities of issuers that are not affiliated persons of the dealer, or (2) a plan referred to in Rule 144A(a)(1)(i)(D) or (E), or a trust fund referred to in Rule 144A(a)(1)(i)(F) that holds the assets of such a plan, the investment decisions with respect to which are made by the beneficiaries of the plan, unless the investment decision to invest in the Fund is made solely by the fiduciary, trustee, or sponsor of such plan.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_5',
      },
      {
        id: iqID.id_purchase_representations_6,
        showHelp: false,
        helpText: '',
        displayName:
          'The undersigned is a company, all of whose outstanding securities are beneficially owned by qualified purchasers.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_6',
      },
      {
        id: iqID.id_purchase_representations_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Or, the undersigned hereby represents and warrants that: The undersigned is NOT a qualified purchaser.',
        isSelected: false,
        name: '',
        identifier: 'pur-or',
      },
    ],
    qualifiedClientRepresentations: [
      {
        id: iqID.id_client_representations_1,
        showHelp: false,
        helpText: '',
        displayName:
          'A natural person or company that will make a capital commitment to the Fund of at least $1,100,000.',
        isSelected: false,
        name: '',
        identifier: 'Cli_Rep_1',
      },
      {
        id: iqID.id_client_representations_2,
        showHelp: false,
        helpText: '',
        displayName:
          'A natural person or company that either:',
        isSelected: false,
        name: '',
        identifier: 'Cli_Rep_2',
      },
      {
        id: iqID.id_client_representations_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Or, the undersigned hereby represents that: The undersigned is NOT a qualified client.',
        isSelected: false,
        name: '',
        identifier: 'cli-or',
      },
    ],
    naturalPersonOrCompany: [
      {
        id: iqID.id_client_representations_2_a,
        showHelp: true,
        helpText: `For purposes of calculating the net worth of a natural person, the amount of any mortgage or other indebtedness
          secured by such person’s primary residence must be netted against the value of such residence. If the amount of such
          indebtedness is less than the estimated fair market value of such residence, it need not be considered as a liability deducted
          from such natural person’s net worth (except that if the amount of indebtedness outstanding at the time of calculation
          exceeds the amount outstanding 60 days before such time, other than as a result of the acquisition of the primary
          residence, the amount of such excess must be included as a liability). If the amount of such indebtedness exceeds the
          estimated fair market value of such residence, then that excess liability must be deducted from such natural person’s net
          worth.`,
        displayName:
          `Has a net worth (together, in the case of a natural person,
          with assets jointly held with a spouse) of more than
          $2,200,000 (excluding the value of the primary residence of
          such natural person); or`,
        isSelected: false,
        name: '',
        identifier: 'Cli_Rep_2',
        className: 'align-tooltip'
      },
      {
        id: iqID.id_client_representations_2_b,
        showHelp: false,
        helpText: '',
        displayName:
          'Is a qualified purchaser as defined in Section 2(a)(51)(A) of the 1940 Act.',
        isSelected: false,
        name: '',
        identifier: 'Cli_Rep_2',
      },
    ],
    foreignPersonStatusRepresentations: [
      {
        id: iqID.id_foreign_person_1,
        showHelp: false,
        helpText: '',
        displayName:
          'A foreign national (i.e., an individual that is a citizen of a foreign (i.e., non-U.S.) country, even if such person is also a U.S. citizen or green card holder, or an individual who does not owe his or her sole allegiance to the United States).',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_1',
      },
      {
        id: iqID.id_foreign_person_2,
        showHelp: false,
        helpText: '',
        displayName:
          'A foreign government (i.e., any  non-U.S. government or body exercising governmental functions), and any national and subnational governments, including their respective departments, agencies, and instrumentalities.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2',
      },
      {
        id: iqID.id_foreign_person_3,
        showHelp: false,
        helpText: '',
        displayName:
          'A foreign entity, including any branch, partnership, group or sub-group, association, estate, trust, corporation, or division of a corporation, or organization organized or incorporated under the laws of a foreign (i.e., non-U.S.) jurisdiction, if either (a) its principal place of business is outside the United States or (b) its equity securities are primarily traded on one or more foreign exchanges, unless a majority of the equity interest in such entity is ultimately owned by U.S. nationals. For purposes of this question, “principal place of business” means the primary location where an entity’s management directs, controls, or coordinates the entity’s activities, or, in the case of an investment fund, where the  fund’s activities and investments are primarily directed, controlled, or coordinated by or on behalf of the general partner, managing member, or equivalent.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_3',
      },
      {
        id: iqID.id_foreign_person_4,
        showHelp: false,
        helpText: '',
        displayName:
          'An entity over which a foreign person exercises or could exercise control (including a trust, corporation, partnership, limited liability company, or equivalent legal entity organized or incorporated under the laws of any state of the United States over which control is exercised or may be exercisable, in any form, by a foreign national, foreign government or foreign entity (e.g., has a foreign manager or general partner; a  foreign person otherwise participates in important decision-making processes; etc.). For purposes of this question, “control” means the power, direct or indirect, whether exercised or not exercised, to determine, direct, or decide important matters affecting an entity, and includes negative control (i.e., the ability to prevent an entity from making a particular decision).',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_4',
      },
      {
        id: iqID.id_foreign_person_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Not a foreign person under any of the previous definitions included in this Section F or otherwise as defined under Section 721 of the Defense Production Act of 1950, as amended, including all implementing regulations thereof.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat-or',
      },
    ],
   foreignPersonStatusRepresentations2: [
       {
        id: iqID.id_foreign_person_2_1,
        showHelp: false,
        helpText: ``,
        displayName:
          'The  undersigned is  not  an  investment fund  and  no  national or subnational governments of  a  single foreign (i.e.,  non-U.S.)  state holds a voting interest, direct or indirect, of 49 percent or more in the undersigned.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2_1',
      },
      {
        id: iqID.id_foreign_person_2_2,
        showHelp: false,
        helpText: '',
        displayName:
          'The  undersigned is  an  investment fund  and  no  national or subnational governments of  a  single foreign (i.e.,  non-U.S.)  state holds  49  percent or  more  of  the  interest in  the  general partner, managing member, or equivalent of the undersigned.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2_2',
      },
      {
        id: iqID.id_foreign_person_2_or,
        showHelp: false,
        helpText: 'Or, the undersigned hereby represents and warrants that:',
        displayName:
          'The undersigned is an entity and is unable to make any of the two representations immediately above in this question F.2.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2-or',
      },
    ],
    wiringBankStatus: [
       {
        id: iqID.id_wiring_bank_status_1,
        tooltip:
         `As of the date hereof, the countries, territories and organizations (each, a “FATF Country”) that make up the
          membership of the Financial Action Task Force are: Argentina, Australia, Austria, Belgium, Brazil, Canada, China,
          Denmark, European Commission, Finland, France, Germany, Greece, Gulf Co-operation Council, Hong Kong (China),
          Iceland, India, Indonesia, Ireland, Israel, Italy, Japan, Kingdom of the Netherlands, Luxembourg, Malaysia, Mexico, New Zealand,
          Norway, Portugal, Republic of Korea, Saudi Arabia, Singapore, South Africa, Spain, Sweden, Switzerland, Turkey,
          United Kingdom and United States. While the Russian Federation was formerly a FATF Country, its membership was
          suspended on February 24, 2023. (Source: www.fatf-gafi.org.)`,
        radioIdentifier: parseRadioIds(iqID.id_wiring_bank_status_1),
        name: 'J_1_quest',
        displayName:
         `1. Is the bank or other financial institution from which the
          undersigned’s funds will be wired (the “Wiring Bank”) located in the
          United States or another “FATF Country”?`,
        isSelected: [false, false],
        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_wiring_bank_status_1_opt,
        tooltip: ``,
        radioIdentifier: ['', ''],
        name: 'J_1_if_quest',
        displayName:
          'If “No,” in what country is the Wiring Bank located?',
        isSelected: [false, false],
        size: 'large',
        type: 'opt',
        conditional: false,
      },
      {
        id: iqID.id_wiring_bank_status_2,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_wiring_bank_status_2),
        name: 'J_2_quest',
        displayName: '2. Is the undersigned a customer of the Wiring Bank?',
        isSelected: [false, false],
        size: 'large',
        type: 'quest',
      },
    ],
    identificationofSpecialEntities: [
      {
        id: iqID.id_special_entities_1,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_1_quest',
        displayName: '1. ERISA Partner',

        size: 'large',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_1_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_1_a),
        name: 'F_1_a_quest',
        displayName:
          `(a). Is the undersigned (i) an employee benefit plan subject to Part
          4 of Subtitle B of Title I of the Employee Retirement Income
          Security Act of 1974, as amended (“ERISA”); or (ii) a plan
          described in Section 4975(e)(1) of the Internal Revenue Code.
          of 1986, as amended (the “Code”)?`,
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_1_b,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_1_b),
        name: 'F_1_b_quest',
        displayName:
          `(b). Is the undersigned (i) an entity whose underlying assets are
            considered “plan assets” of an employee benefit plan that is
            subject to Part 4 of Subtitle B of Title I of ERISA and that
            invested in such entity or (ii) an entity whose underlying assets
            are considered “plan assets” of a plan that is described in
            Section 4975(e)(1) of the Code and that invested in such entity?`,

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_1_b_opt,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_1_b_if_quest',
        displayName:
          'If "Yes", what percentage of the undersigned’s underlying assets is considered “plan assets”?',
        size: 'col-lg-5 col-md-5 col-sm-5 col-xs-5 tab-space',
        type: 'opt',
        conditional: true,
      },
      {
        id: iqID.id_special_entities_2,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_2_quest',
        displayName: '2. Potential Look-through Entity',

        size: 'large',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_2_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_2_a),
        name: 'F_2_a_quest',
        displayName:
          '(a). Is the undersigned, or would the undersigned be but for the exception provided in either Section 3(c)(1) or Section 3(c)(7) of the 1940 Act, an “investment company,” as defined in the 1940 Act?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
     {
        id: iqID.id_special_entities_2_e_opt,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_2_e_quest',
        displayName:
          '(b). If the answer to question 2(a) above is “Yes,” how many beneficial owners does the undersigned have for purposes of Section 3(c)(1) of the 1940 Act?',
        size: 'col-lg-5 col-md-5 col-sm-5 col-xs-5 tab-space',
        type: 'opt',
        conditional: false,
      },
      {
        id: iqID.id_investor_status_4,
        tooltip:
          `A member of FINRA is defined by FINRA as being either any individual, partnership, corporation or other legal entity
          that is a broker or dealer admitted to membership in FINRA or any officer or partner of such a member, or the executive
          representative of such a member or the substitute for such a representative.
          <br><br/>
          An affiliate of a FINRA member is any person that controls, is controlled by, or is under common control with such
          FINRA member. Without limiting the foregoing in any way, a person will be presumed to control a FINRA member if
          such person owns 10% or more of the economic interest or voting power in such FINRA member. A FINRA member will
          be presumed to control a company if the member has 10% or more of the economic interest or voting power in such
          company. A company and a FINRA member will be presumed to be under common control if a single person owns 10%
          or more of the economic interest or voting power in both such other company and such FINRA member. A company and
          a FINRA member will also be presumed to be under common control if another person has the power to direct or cause
          the direction of the management or policies of both the FINRA member and such other company. (FINRA Rule
          5121(f)(6))
          <br><br/>
           A person associated with a FINRA member means a natural person which is registered or has applied for registration under
          the FINRA rules and every sole proprietor, partner, officer, director or branch manager of any FINRA member, or any natural
          person occupying a similar status or performing similar functions, or any natural person engaged in the investment banking or
          securities business who is directly or indirectly controlling or controlled by a FINRA member, whether or not such person is
          registered or exempt from registration with FINRA pursuant to its Bylaws.`,
        radioIdentifier: parseRadioIds(iqID.id_investor_status_4),
        name: 'E_4_quest',
        displayName:
          '3. FINRA Affiliation: Is the undersigned (a) a member of the Financial Industry Regulatory Authority (“FINRA,” which was formerly known as the National Association of Securities Dealers or NASD), (b) a person affiliated with a FINRA member, (c) a person associated with a FINRA member or (d) a person directly or indirectly engaged in the securities business as a broker, dealer or underwriter, whether as an employee, director, partner, registered representative or otherwise?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_3,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_3_quest',
        displayName:
          '4. Government Entity: Is the undersigned a state or political subdivision of a state, including:',
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_3_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_3_a),
        name: 'F_3_a_quest',
        displayName: '',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_4,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_4),
        name: 'F_4_quest',
        displayName:
          `5. Bank Holding Company Partner: Is the undersigned a bank holding
          company or a company otherwise subject to the Bank Holding Company
          Act of 1956, as amended (the “Bank Holding Company Act”), or a
          subsidiary of such bank holding company?`,
        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_4_a,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_3_quest',
        displayName:
          `By executing this Investor Questionnaire, if either a Bank Holding
          Company or a Financial Holding Company Partner, the undersigned (i)
          represents and warrants that its investment in the Fund does not violate
          Section 13 of the Bank Holding Company Act (the “Volcker Rule”) and (ii)
          if admitted to the Fund, covenants that it shall immediately provide the
          General Partner with written notice if the holding of an interest in the
          Fund would subsequently cause the undersigned to violate the Volcker
          Rule.`,
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_5,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_5),
        name: 'F_5_quest',
        displayName:
          '6. Private Foundation Partner: Is the undersigned a “private foundation” as described in Section 509 of the Code?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_6,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_6),
        name: 'F_6_quest',
        displayName:
          '7. Public Pension Partner: Is the undersigned (a) a pension fund or retirement system for a government entity, or (b) a partnership of which one or more partners is a pension fund or retirement system for a government entity?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_10,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_10),
        name: 'F_6_quest',
        displayName:
        `8. Foreign Partner: Is the undersigned (a) not a “United States person” as
          defined in section 7701(a)(30) of the Code, or (b) a domestic partnership of
          which one or more persons or entities that are not “United States person”
          as defined in section 7701(a)(30) of the Code, own an interest in the
          partnership capital of such domestic partnership, as defined in sections
          7701(a)(2) and 7701(a)(4) of the Code?`,
        size: 'large',
        type: 'quest',
      },
       {
        id: iqID.id_special_entities_8,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_8),
        name: 'E_1_quest',
        displayName:
        `9. Tax-Exempt Partner Is the undersigned either (a) exempt from the payment of United States federal income tax or (b) a partnership (or entity treated as such for tax purposes), one or more of the partners or equity owners of which is exempt from the payment of United States federal income tax?`,
        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_2,
        tooltip: `
        <p>For purposes of such Rule 902(k), “U.S. person” means:</p>
       <p>i. Any natural person resident in the United States;
       <br/>
        ii. Any partnership or corporation organized or incorporated under the laws of the United
        States;
        <br/>
        iii. Any estate of which any executor or administrator is a U.S. person;
        <br/>
        iv. Any trust of which any trustee is a U.S. person;
        <br/>
        v. Any agency or branch of a foreign entity located in the United States;
        <br/>
        vi. Any non-discretionary account or similar account (other than an estate or trust) held by
        a dealer or other fiduciary for the benefit or account of a U.S. person;
        <br/>
        vii. Any discretionary account or similar account (other than an estate or trust) held by a
        dealer or other fiduciary organized, incorporated, or (if an individual) resident in the
        United States; and
        <br/>
        viii. Any partnership or corporation if:
        A. Organized or incorporated under the laws of any foreign jurisdiction; and
        B. Formed by a U.S. person principally for the purpose of investing in
        securities not registered under the Act, unless it is organized or
        incorporated, and owned, by accredited investors (as defined in Rule
        501(a)) who are not natural persons, estates or trusts.</p>
        
        <p>The following are not “U.S. persons”:</p>
        <p>
        i. Any discretionary account or similar account (other than an estate or trust) held for the
        benefit or account of a non-U.S. person by a dealer or other professional fiduciary
        organized, incorporated, or (if an individual) resident in the United States;
         <br/>
        ii. Any estate of which any professional fiduciary acting as executor or administrator is a
        U.S. person if:
        A. An executor or administrator of the estate who is not a U.S. person has sole
        or shared investment discretion with respect to the assets of the estate; and
        B. The estate is governed by foreign law;
        <br/>
        iii. Any trust of which any professional fiduciary acting as trustee is a U.S. person, if a
        trustee who is not a U.S. person has sole or shared investment discretion with respect to
        the trust assets, and no beneficiary of the trust (and no settlor if the trust is revocable) is
        a U.S. person;
        <br/>
        iv. An employee benefit plan established and administered in accordance with the law of a
        country other than the United States and customary practices and documentation of
        such country;
        <br/>
        v. Any agency or branch of a U.S. person located outside the United States if:
        A. The agency or branch operates for valid business reasons; and
        B. The agency or branch is engaged in the business of insurance or banking
        and is subject to substantive insurance or banking regulation, respectively,
        in the jurisdiction where located; and
        <br/>
        vi. The International Monetary Fund, the International Bank for Reconstruction and
        Development, the Inter-American Development Bank, the Asian Development Bank, the
        African Development Bank, the United Nations, and their agencies, affiliates and
        pension plans, and any other similar international organizations, their agencies,
        affiliates and pension plans.</p>`,
        radioIdentifier: parseRadioIds(iqID.id_investor_status_2),
        name: 'E_2_quest',
        displayName:
          '10. U.S. Person: Is the undersigned a “U.S. Person” as defined in Rule 902(k) promulgated under the United States Securities Act of 1933?',
        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_7,
        tooltip:
          'The U.S. Securities and Exchange Commission has not defined a “fund-of-funds,” but has indicated that the term can be interpreted in a reasonable manner in accordance with industry parlance, and has suggested that a pooled investment vehicle that invests 10% or more of its capital in other pooled investment vehicles is a “fund-of-funds.”',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_7),
        name: 'F_7_quest',
        displayName: '11. Fund-of-Funds: Is the undersigned a “fund-of-funds”?',
        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_6,
        tooltip:
          'Rule 506(d) disqualifies persons who have been convicted of certain felonies and misdemeanors or who have been subject to certain orders, judgments or decrees.<br /><br />“Bad Actor” Disqualification: Rule 506(d) of Regulation D promulgated by the Securities and Exchange Commission states:<br /><br /><div class="tooltip-list-item">(d) “Bad Actor” disqualification.  (1) No exemption under this section shall be available for a sale of securities if the issuer; any predecessor of the issuer; any affiliated issuer; any director, executive officer, other officer participating in the offering, general partner or managing member of the issuer; any beneficial owner of 20% or more of the issuer’s outstanding voting equity securities, calculated on the basis of voting power; any promoter connected with the issuer in any capacity at the time of such sale; any investment manager of an issuer that is a pooled investment fund; any person that has been or  will  be  paid  (directly  or  indirectly)  remuneration  for  solicitation  of  purchasers  in  connection  with such sale of securities; any general partner or managing member of any such investment manager or solicitor;  or  any  director,  executive  officer  or  other  officer  participating  in  the  offering  of  any  such investment manager or solicitor or general partner or managing member of such investment manager or solicitor:</div><div class="tooltip-list-item">(i)  Has  been  convicted,  within  ten  years  before  such  sale  (or  five  years,  in  the  case  of  issuers, their predecessors and affiliated issuers), of any felony or misdemeanor:</div><div class="tooltip-list-item">(A) In connection with the purchase or sale of any security; </div><div class="tooltip-list-item">(B) Involving the making of any false filing with the Commission; or</div><div class="tooltip-list-item">(C)  Arising  out  of  the  conduct  of  the  business  of  an  underwriter,  broker,  dealer,  municipal securities dealer, investment adviser or paid solicitor of purchasers of securities;</div><div class="tooltip-list-item">(ii)  Is  subject  to  any  order,  judgment  or  decree  of  any  court  of  competent  jurisdiction,  entered within five years before such sale, that, at the time of such sale, restrains or enjoins such person from engaging or continuing to engage in any conduct or practice:</div><div class="tooltip-list-item">(A) In connection with the purchase or sale of any security;</div><div class="tooltip-list-item">(B) Involving the making of any false filing with the Commission; or</div><div class="tooltip-list-item">(C)  Arising  out  of  the  conduct  of  the  business  of  an  underwriter,  broker,  dealer,  municipal securities dealer, investment adviser or paid solicitor of purchasers of securities;</div><div class="tooltip-list-item">(iii) Is subject to a final order of a state securities commission (or an agency or officer of a state performing like functions); a state authority that supervises or examines banks, savings associations, or  credit  unions;  a  state  insurance  commission  (or  an  agency  or  officer  of  a  state  performing  like functions); an appropriate federal banking agency; the U.S. Commodity Futures Trading Commission; or the National Credit Union Administration that: </div><div class="tooltip-list-item">(A) At the time of such sale, bars the person from:</div><div class="tooltip-list-item">( 1 ) Association with an entity regulated by such commission, authority, agency, or officer;</div><div class="tooltip-list-item">( 2 ) Engaging in the business of securities, insurance or banking; or</div><div class="tooltip-list-item">( 3 ) Engaging in savings association or credit union activities; or</div><div class="tooltip-list-item">(B)  Constitutes  a  final  order  based  on  a  violation  of  any  law  or  regulation  that  prohibits fraudulent, manipulative, or deceptive conduct entered within ten years before such sale;</div><div class="tooltip-list-item">(iv) Is subject to an order of the Commission entered pursuant to section 15(b) or 15B(c) of the Securities  Exchange  Act  of  1934  (15  U.S.C.  78 o  (b)  or  78 o  -4(c))  or  section  203(e)  or  (f)  of  the Investment Advisers Act of 1940 (15 U.S.C. 80b-3(e) or (f)) that, at the time of such sale:</div><div class="tooltip-list-item">(A)  Suspends  or  revokes  such  person’s  registration  as  a  broker,  dealer,  municipal  securities dealer or investment adviser;</div><div class="tooltip-list-item">(B) Places limitations on the activities, functions or operations of such person; or</div><div class="tooltip-list-item">(C) Bars such person from being associated with any entity or from participating in the offering of any penny stock;</div><div class="tooltip-list-item">(v) Is subject to any order of the Commission entered within five years before such sale that, at the time of such sale, orders the person to cease and desist from committing or causing a violation or future violation of:</div><div class="tooltip-list-item">(A)  Any  scienter-based  anti-fraud  provision  of  the  federal  securities  laws,  including  without limitation  section  17(a)(1)  of  the  Securities  Act  of  1933  (15  U.S.C.  77q(a)(1)),  section  10(b)  of  the Securities  Exchange  Act  of  1934  (15  U.S.C.  78j(b))  and  17  CFR  240.10b-5,  section  15(c)(1)  of  the Securities  Exchange  Act  of  1934  (15  U.S.C.  78 o  (c)(1))  and  section  206(1)  of  the  Investment Advisers Act of 1940 (15 U.S.C. 80b-6(1)), or any other rule or regulation thereunder; or</div><div class="tooltip-list-item">(B) Section 5 of the Securities Act of 1933 (15 U.S.C. 77e).</div><div class="tooltip-list-item">(vi) Is suspended or expelled from membership in, or suspended or barred from association with a member of, a registered national securities exchange or a registered national or affiliated securities association  for  any  act  or  omission  to  act  constituting  conduct  inconsistent  with  just  and  equitable principles of trade</div><div class="tooltip-list-item">(vii)  Has  filed  (as  a  registrant  or  issuer),  or  was  or  was  named  as  an  underwriter  in,  any registration  statement  or  Regulation  A  offering  statement  filed  with  the  Commission  that,  within  five years  before  such  sale,  was  the  subject  of  a  refusal  order,  stop  order,  or  order  suspending  the Regulation A exemption, or is, at the time of such sale, the subject of an investigation or proceeding to determine whether a stop order or suspension order should be issued; or</div><div class="tooltip-list-item"></div><div class="tooltip-list-item">(viii)  Is  subject  to  a  United  States  Postal  Service  false  representation  order  entered  within  five years  before  such  sale,  or  is,  at  the  time  of  such  sale,  subject  to  a  temporary  restraining  order  or preliminary injunction with respect to conduct alleged by the United States Postal Service to constitute a  scheme  or  device  for  obtaining  money  or  property  through  the  mail  by  means  of  false representations.</div><div class="tooltip-list-item">(2) Paragraph (d)(1) of this section shall not apply:</div><div class="tooltip-list-item">(i)  With  respect  to  any  conviction,  order,  judgment,  decree,  suspension,  expulsion  or  bar  that occurred or was issued before September 23, 2013; </div><div class="tooltip-list-item">(ii) Upon a showing of good cause and without prejudice to any other action by the Commission, if the Commission determines that it is not necessary under the circumstances that an exemption be denied; </div><div class="tooltip-list-item">(iii) If, before the relevant sale, the court or regulatory authority that entered the relevant order, judgment or decree advises in writing (whether contained in the relevant judgment, order or decree or separately to the Commission or its staff) that disqualification under paragraph (d)(1) of this section should not arise as a consequence of such order, judgment or decree; or</div><div class="tooltip-list-item">(iv) If the issuer establishes that it did not know and, in the exercise of reasonable care, could not have known that a disqualification existed under paragraph (d)(1) of this section.</div><div class="tooltip-list-item">nstruction  to  paragraph  (d)(2)(iv).  An  issuer  will  not  be  able  to  establish  that  it  has  exercised reasonable  care  unless  it  has  made,  in  light  of  the  circumstances,  factual  inquiry  into  whether  any disqualifications  exist.  The  nature  and  scope  of  the  factual  inquiry  will  vary  based  on  the  facts  and circumstances concerning, among other things, the issuer and the other offering participants.</div><div class="tooltip-list-item">(3) For purposes of paragraph (d)(1) of this section, events relating to any affiliated issuer that occurred before the affiliation arose will be not considered disqualifying if the affiliated entity is not: </div><div class="tooltip-list-item">(i) In control of the issuer; or</div><div class="tooltip-list-item">(ii)  Under  common  control  with  the  issuer  by  a  third  party  that  was  in  control  of  the  affiliated entity at the time of such events.</div>',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_6),
        name: 'E_6_quest',
        displayName:
          '12. “Bad Actor” Disqualification: Is the undersigned subject to “Bad Actor” disqualification, as such term is used in Rule 506(d) of Regulation D promulgated by the Securities and Exchange Commission?',
        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'E_5_quest',
        displayName: '13. FOIA Partner:',

        size: 'large',
        type: 'title',
      },
      {
        id: iqID.id_investor_status_5_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_a),
        name: 'E_5_a_quest',
        displayName:
          '(a). Is the undersigned a person that is directly or indirectly subject to either section 552(a) of Title 5, United States Code (commonly known as the “Freedom of Information Act”) or any similar federal, state, county or municipal public disclosure law, whether foreign or domestic?:',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_b,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_b),
        name: 'E_5_b_quest',
        displayName:
          '(b). Is the undersigned a person that is subject, by regulation, contract or otherwise, to disclose Fund information due to regulatory or trading exchange or other market requirements where interests in such Person are registered, regulated, sold or traded, whether foreign or domestic?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_c,
        tooltip: `The US Securities and Exchange Commission has not defined a “fund-of-funds,” but has indicated that the term can
          be interpreted in a reasonable manner in accordance with industry parlance, and has suggested that a pooled investment
          vehicle that invests 10% or more of its capital in other pooled investment vehicles is a “fund-of-funds.”
           Rule 506(d) disqualifies persons who have been convicted of certain felonies and misdemeanors or who have been
          subject to certain orders, judgments or decrees. The full text of Rule 506(d) may be found in Exhibit A to this Investor
          Questionnaire.`,
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_c),
        name: 'E_5_c_quest',
        displayName:
          '(c). Is the undersigned a person that is required to or will likely be required to disclose Fund information to a governmental body, agency or committee (including, without limitation, any disclosures required in accordance with the Ethics in Government Act of 1978, as amended, and any rules and regulations of any executive, legislative or judiciary organization), whether foreign or domestic, by virtue of such person’s (or any of its affiliates) current or proposed involvement in government office?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_d,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_d),
        name: 'E_5_d_quest',
        displayName:
        `(d) Is the undersigned a person that is an agent, nominee, fiduciary,
          custodian or trustee for any person described in the preceding
          questions 13(a) through 13(c) where Fund information provided or
          disclosed to the undersigned, as a limited partner of the Fund, by or
          on behalf of the Fund, its General Partner or its management
          company is provided or could at any time become available to such
          person described by the preceding questions 13(a) through 13(c)?`,
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_e,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_e),
        name: 'E_5_e_quest',
        displayName:
        `(e) Is the undersigned a person that is an investment fund or other entity
          that has any person described in the preceding questions 13(a)
          through 13(d) as a partner, member or other beneficial owner where
          Fund information provided or disclosed to the undersigned, as a
          limited partner of the Fund, by or on behalf of the Fund, its General
          Partner or its management company is disclosed to or could at any
          time become available to such person described by the preceding
          questions 13(a) through 13(d)?`,
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_f,
        tooltip: ``,
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_f),
        name: iqID.id_investor_status_5_f,
        displayName:
          `(f). If the answer to any of 13(a) through 13(e) above is "Yes," does the
          undersigned reasonably believe (based on the advice of
          counsel) that it is not required by law to disclose
          any Portfolio Company Information provided or disclosed to the
          undersigned by the Fund, the General Partner or any
          affiliate or agent thereof? As used herein, Portfolio Company
          Information shall mean any financial information, valuation or other confidential
          information (other than the name of the portfolio company and the
          cost basis of the investment) relating to the Fund’s current, past or
          prospective portfolio companies.`,
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_retirementPlan,
        tooltip: ``,
        radioIdentifier: parseRadioIds(iqID.id_retirementPlan),
        name: 'E_5_f_quest',
        displayName:
          `14. Retirement Plan. For purposes of Item I2 of the Schedule K-1 (Form 1065)
          to be issued to the Limited Partner, is the undersigned a retirement plan
          (IRA/SEP/Keogh/etc.)?`,
        size: 'large',
        type: 'quest',
      },
    ],
    warrantiesExceptions: [
      {
        id: iqID.id_warranties_exceptions,
        tooltip: '',
        description:
          '',
        radioIdentifier: ['', ''],
        name: 'W_1_quest',
        displayName: 'Warranties Exceptions',

        size: 'large',
        type: 'quest',
      },
    ],
    additionalContactInfo: [
      {
        id: iqID.id_additional_contact_info,
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_additional_contact_info),
        displayName:'Same as Currently on File with the Fund Manager?',
        isSelected: false,
        tooltip: '',
        name: 'additional_contact_info',
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 general-information-question',
        identifier: 'additional_contact_info',
        answer: '',
      },
    ],
    miscellaneous: [
      {
        id: 'miscellaneous_1',
        displayName: `The person signing this Investor Questionnaire on
          behalf of the undersigned is duly authorized to sign
          and enter into this Investor Questionnaire on behalf
          of the undersigned.`,
      },
      {
        id: 'miscellaneous_2',
        displayName: `Neither this Investor Questionnaire nor any term
          hereof may be changed, waived, discharged or
          terminated orally but only with the written consent of
          the undersigned and the General Partner.`,
      },
      {
        id: 'miscellaneous_3',
        displayName: `The undersigned acknowledges that this Investor
          Questionnaire contains certain representations and
          warranties made by the undersigned to the Fund. The
          undersigned acknowledges that the undersigned
          understands the meaning and legal consequences of the
          representations and warranties made by the undersigned
          herein and that the Fund is relying on such
          representations and warranties in making its
          determination to admit the undersigned to the Fund.`,
      },
      {
        id: 'miscellaneous_4',
        displayName: `The undersigned hereby agrees to indemnify and hold
          harmless the Fund, the general partner of the Fund, and each
          member, partner, director, officer or employee of the
          general partner of the Fund from and against any and all loss,
          damage, liability or expenses, including legal fees
          and expenses, due to or arising out of a breach of any
          representation or warranty of the undersigned.`,
      },
      {
        id: 'miscellaneous_5',
        displayName: `This Investor Questionnaire shall be construed in
          accordance with and governed by the laws of the State
          of Delaware.`,
      },
      {
        id: 'miscellaneous_6',
        displayName: `This Investor Questionnaire may be executed in any
          number of counterparts, each of which shall be an
          original but all of which taken together shall
          constitute one agreement.`,
      },
      {
        id: 'miscellaneous_7',
        displayName: `The headings in this Investor Questionnaire are for
          convenience of reference, and shall not by themselves
          determine the meaning of this Investor Questionnaire
          or of any part thereof.`,
      },
      {
        id: 'miscellaneous_8',
        displayName: `The English language version of this Investor
          Questionnaire shall govern all questions of
          interpretation relating to this Investor
          Questionnaire, notwithstanding that this Investor
          Questionnaire may have been translated into, and
          executed in, other languages.`,
      },
      {
        id: 'miscellaneous_9',
        displayName: `The undersigned makes the following exceptions to any of the foregoing representations and warranties contained in this Investor Questionnaire:`
      }
    ],
    additionalDistributionInfo: [
      {
        id: iqID.id_additional_contact_info,
        showHelp: false,
        helpText: '',
        radioIdentifier: parseRadioIds(iqID.id_additional_contact_info),
        displayName:'Same as Currently on File with the Fund Manager?',
        isSelected: false,
        tooltip: '',
        name: 'additional_contact_info',
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 general-information-question',
        identifier: 'additional_contact_info',
        answer: '',
      },
    ],
  },
};
